import { render, staticRenderFns } from "./PageInfoAllianz.vue?vue&type=template&id=6d2d01d2"
import script from "./PageInfoAllianz.vue?vue&type=script&lang=js"
export * from "./PageInfoAllianz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports